<template>
	<channel-list compact ref="channelList"></channel-list>
</template>

<script>
import ChannelList from './components/ChannelList.vue';

export default {
	components: {
		ChannelList,
	},
	created() {
		this.$auth.loadFromLocalStorage();
		if(!this.$auth.isLoggedIn()) document.location = `${process.env.VUE_APP_PIPIPUPUBASE}/app?redirect=${document.location}`;
	},
}
</script>

<style>
html.obs ::-webkit-scrollbar { width: 10px }
html.obs ::-webkit-scrollbar-track { background: #241e32 }
html.obs ::-webkit-scrollbar-thumb { background: #eb5dff; border-radius: 5px }
html.obs ::-webkit-scrollbar-thumb:hover { background: #5df286 }
</style>
